// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2hADR","inputWrap":"Table_inputWrap__2IZCl","col":"Table_col__33DQC","bmiTooltip":"Table_bmiTooltip__tevRo"};